<template>
  <div class="integral">
    <van-tabs v-model="active" color="#5a9bf6" @change="onChange">
      <van-tab title="用户积分"></van-tab>
      <van-tab title="志愿者积分" v-if="sumScore.volunteerScore"></van-tab>
      <!-- <van-tab title="志愿者积分"  ></van-tab> -->
    </van-tabs>
    <div class="g-layout">
      <div class="g-header">
        <div class="integral-top">
          <i class="iconfont iconjifen1"></i>积分明细
        </div>
        <div class="integral-topRight">
          总积分：
          <span class="f-color-FF8D09 f-size-14">{{total}}</span>
        </div>
      </div>
      <div class="integralBox" v-for="item in list" :key="item.id">
        <div class="integralBox-top">
          <div class="integralBox-topLeft">{{item.description}}</div>
          <div class="integralBox-topRight">{{item.operateTime}}</div>
        </div>
        <div class="integralBox-bottom">
          <div class="integralBox-bottomLeft">
            积分：
            <span class="textStyle">{{item.scoreNum}}</span>
          </div>
          <div class="integralBox-bottomRight">{{item.condition}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tab, Tabs } from "vant";
import http from "@js/http-zyz.js";
import { getDetailScoreByOpenid } from "@js/volunteerUrl";

export default {
  name: "Integral",
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  data() {
    return {
      active: 0,
      totalIntegral: "1000",
      list: [],
      sumScore: {}
    };
  },
  created() {
    let { index = 0, sumScore } = this.$route.query;
    this.sumScore = sumScore;
    this.active = index;
    this.onChange(index);
  },
  methods: {
    onChange(index) {
      index == 0 ? this.getUser() : this.getVolunteer();
    },
    getUser() {
      http
        .post(getDetailScoreByOpenid, { openId: this.openId, userType: 1 })
        .then(res => {
          this.list = res.data.data;
        });
    },
    getVolunteer() {
      http
        .post(getDetailScoreByOpenid, { openId: this.openId, userType: 2 })
        .then(res => {
          this.list = res.data.data;
        });
    }
  },
  computed: {
    openId() {
      return this.$store.state.userInfo.openId;
    },
    total() {
      return this.active == 0
        ? this.sumScore.userScore
        : this.sumScore.volunteerScore;
    }
  }
};
</script>

<style lang="less" scoped>
.integral {
  background-color: #eff0fa !important;
  .g-layout {
    padding: 0 8px;
  }
  .g-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    zoom: 1;
    margin-top: 10px;
    padding: 0 10px;
  }

  .integral-top {
    color: #606060;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    .iconfont {
      color: #5a9bf6;
      padding-right: 6px;
      font-size: 18px;
    }
  }
  .integral-topRight {
    font-weight: 500;
    line-height: 20px;
    color: #606060;
    font-size: 14px;
  }
  .f-color-FF8D09 {
    color: #ff8d09;
  }
  .f-size-14 {
    font-size: 14px;
  }
  .integralBox {
    margin-top: 15px;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    padding: 0 8px;
    .integralBox-top {
      padding: 14px 7px;
      zoom: 1;
      overflow: auto;
      border-bottom: 0.5px solid #d8d8d8;
      .integralBox-topLeft {
        float: left;
        color: #606060;
        font-size: 14px;
        line-height: 20px;
      }
      .integralBox-topRight {
        float: right;
        color: #b3b3b3;
        font-size: 12px;
        line-height: 20px;
      }
    }
    .integralBox-bottom {
      padding: 14px 7px;
      zoom: 1;
      overflow: auto;
      .integralBox-bottomLeft {
        float: left;
        color: #b3b3b3;
        font-size: 14px;
        line-height: 20px;
        .textStyle {
          color: #ff8d09;
          font-size: 14px;
        }
      }
      .integralBox-bottomRight {
        float: right;
        color: #27af2d;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
}
</style>